module.exports = __webpack_public_path__ + "img/custom-playlist-vector.266ba6df.png";